import { DVER } from "divine-voxel-engine/Render";
import { CreateBox } from "@babylonjs/core/Meshes/Builders/boxBuilder.js";
import { HemisphericLight } from "@babylonjs/core/Lights/hemisphericLight";
import "@babylonjs/core/Animations/animatable";
import "@babylonjs/core/Meshes/thinInstanceMesh";
import { RawTexture2DArray } from "@babylonjs/core/Materials/Textures/rawTexture2DArray.js";
import { Texture } from "@babylonjs/core/Materials/Textures/texture.js";
import { Scene } from "@babylonjs/core/scene.js";
import { Engine } from "@babylonjs/core/Engines/engine.js";
import { Vector3, Vector4 } from "@babylonjs/core/Maths/math.vector.js";
import { Color3 } from "@babylonjs/core/Maths/math.color.js";
import { Effect } from "@babylonjs/core/Materials/effect.js";
import { Mesh } from "@babylonjs/core/Meshes/mesh.js";
import { Geometry } from "@babylonjs/core/Meshes/geometry.js";
import { UniversalCamera } from "@babylonjs/core/Cameras/universalCamera.js";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode.js";
import { ShaderMaterial } from "@babylonjs/core/Materials/shaderMaterial.js";
import { BoundingBox } from "@babylonjs/core/Culling/boundingBox.js";
import { BoundingInfo } from "@babylonjs/core/Culling/boundingInfo.js";
import { VertexBuffer } from "@babylonjs/core/Meshes/buffer.js";
import { RenderSystem } from "../../system/render/RenderSystem";
import { InitPlayer } from "../../player/InitPlayer";
//  "./Contexts/DataLoader/dataloader.js",
export async function INIT_DVER() {
    // await $INITDataLoader(DVER);
    const canvas = RenderSystem.createRenderCanvas();
    let antialias = false;
    const engine = new Engine(canvas, antialias);
    engine.doNotHandleContextLost = true;
    engine.enableOfflineSupport = false;
    engine.setSize(1920, 1080);
    engine.setSize(window.innerWidth, window.innerHeight);
    window.addEventListener("resize", function () {
        engine.resize();
    });
    const scene = new Scene(engine);
    await DVER.$SCENEINIT({
        scene: scene,
        system: {
            //@ts-ignore
            Scene,
            //@ts-ignore
            Engine,
            //@ts-ignore
            RawTexture2DArray,
            //@ts-ignore
            Texture,
            //@ts-ignore
            Vector3,
            //@ts-ignore
            Vector4,
            //@ts-ignore
            UniversalCamera,
            //@ts-ignore
            TransformNode,
            //@ts-ignore
            ShaderMaterial,
            //@ts-ignore
            Mesh,
            //@ts-ignore
            BoundingBox,
            //@ts-ignore
            BoundingInfo,
            //@ts-ignore
            Geometry,
            //@ts-ignore
            Effect,
            //@ts-ignore
            Color3,
            //@ts-ignore
            VertexBuffer,
        },
    });
    scene.fogEnabled = true;
    scene.autoClear = false;
    scene.autoClearDepthAndStencil = false;
    scene.skipPointerMovePicking = true;
    scene.constantlyUpdateMeshUnderPointer = false;
    const camera = new UniversalCamera("", Vector3.Zero());
    camera.touchAngularSensibility = 10000;
    camera.speed = 1;
    camera.maxZ = 1000;
    camera.fov = 1.2;
    camera.attachControl(canvas, true);
    scene.activeCamera = camera;
    scene.collisionsEnabled = false;
    camera.inertia = 0.2;
    const hemLight = new HemisphericLight("", new Vector3(0, 1, 0), scene);
    const skybox = CreateBox("skyBox", { size: 800.0 }, scene);
    skybox.infiniteDistance = true;
    const bmat = DVER.nodes.materials.get("#dve_skybox");
    if (bmat) {
        //@ts-ignore
        skybox.material = bmat.getMaterial();
    }
    const sceneTool = DVER.getSceneTool();
    sceneTool.levels
        .setSun(0.8)
        .levels.setBase(0.1)
        .fog.setColor(0.6)
        .fog.setMode("volumetric")
        .fog.setDensity(0.0005);
    sceneTool.options.doEffects(true).doAO(true).doRGB(true).doSun(true);
    engine.runRenderLoop(() => {
        scene.render();
    });
    const nodeMeshTool = DVER.getNodeMeshTool();
    const meshes = [];
    const addVoxelEntity = async (id, positon) => {
        const voxelMesh = await nodeMeshTool
            .setXYZ(0, 0, 0)
            .voxel.buildAsync(nodeMeshTool.voxel.dataTool
            .setStringId(id)
            .setLevelState(1)
            .setLevel(15)
            .getRaw());
        if (!voxelMesh)
            return;
        voxelMesh.setInstanceAmount(1000);
        let i = 0;
        const instances = [];
        while (i < 20) {
            const instance = voxelMesh.getInstance();
            if (!instance)
                break;
            instance.position.set(positon.x, i + 60, positon.z);
            instance.update();
            instances.push(instance);
            i++;
        }
        setInterval(() => {
            for (const instance of instances) {
                instance.rotation.y += Math.PI / 100;
                //   instance.rotation.x += Math.PI/100;
                //     instance.rotation.z += Math.PI/100;
            }
            voxelMesh.update();
            //  voxelMesh.mesh.rotation.y += 1;
        }, 60);
        meshes.push(voxelMesh);
    };
    const voxels = [
        "dve_dread_stone",
        "dve_dream_grass",
        "dve_dream_stone_stair",
        "dve_liquid_dream_ether",
    ];
    setTimeout(async () => {
        let x = 0;
        for (const voxel of voxels) {
            await addVoxelEntity(voxel, new Vector3(x, 62, 0));
            x += 2;
        }
    }, 5_000);
    InitPlayer(scene, camera);
    self.DVER = DVER;
}
